/**
 * Created by han on 1/23/2019.
 */

import development from '../../environment/development';
development();

class Events {

	constructor() {
		this.listeners = {};
	}

	on(event, handler) {
		// exit if error
		if (!typeof event === 'string' || !typeof handler === 'function') return this;
		// create eventType if don't exist
		if (!this.listeners[event]) this.listeners[event] = [];
		// push handler
		this.listeners[event].push( handler );
		return this;
	}

	off(event, handler) {
		// exit if error
		if (!typeof event === 'string' && !typeof handler === 'function') return this;
		// exit if listener not exist
		if (!this.listeners && !Array.isArray(this.listeners[event])) return this;
		// find event handler
		const listener = this.listeners[event];
		listener.forEach((fn, i) => {
			if (fn === handler) listener.splice(i, i + 1);
		});
		return this;
	}

	once(event, handler) {
		// exit if error
		if (!typeof event === 'string' && !typeof handler === 'function') return this;
		// exit if listener not exist
		if (!this.listeners && !Array.isArray(this.listeners[event])) return this;
		// off after emit
		function onceHandler(...args) {
			handler.apply(this, args);
			this.off(event, onceHandler);
		}
		return this.on(event, onceHandler);
	}

	emit(event, ...args) {
		// exit if type not a string
		if (typeof event !== 'string') return this;
		// exit if listeners not exist
		if (!this.listeners) return this;
		// exit if event handler not exist
		const listener = this.listeners[event];
		if (!listener) return this;
		// emitting
		Object.keys(listener).forEach(handler => {
			listener[handler].bind(this, ...args)();
		});
		return this;
	}
}

class App extends Events {

	constructor(listeners = {}) {
		super(listeners);
	}

	init() {
		this.emit('init');
	}

	use(components) {
		if ( !Array.isArray(components) ) return this;
		// install components
		for (let i=0; i<components.length; i++) {
			const component = components[i];
			// dynamic import
			if ( typeof component.then === 'function' ) {
				component.then( _ => {
					this.install( _.default, () => {
						this.emit( _.default.name+'Dynamic');
					});
				});
			} else {
				this.install( component );
			}
		}
		// after install
		this.init();
	}

	install(component, callback) {
		const listeners = component.on;
		if ( typeof listeners === 'object' ) {
			Object.keys( listeners ).forEach( eventName => {
				this.on(eventName, listeners[eventName].bind(this) );
			});
		}
		// install component
		const name = component.name;
		this[name] = component[name];

		if ( callback ) callback();
	}
}

export default new App();